import { fetchCanonicalLinkPreview } from "./canonicalMessagingApi";
const requests = new Map();
let session;
export function clearLinkPreviewCache() { requests.clear(); session = undefined; }
export function evictLinkPreviews(urls) {
  urls.forEach(url => { try { requests.delete(new URL(url).href); } catch { /* Invalid preview URLs were never requested. */ } });
}
export function loadLinkPreview(url) {
  const token = localStorage.getItem("accessToken");
  if (session !== token) { requests.clear(); session = token; }
  if (requests.has(url)) return requests.get(url);
  const promise = (async () => {
    for (let attempt = 0; attempt <= 3; attempt++) {
      if (localStorage.getItem("accessToken") !== token) throw new Error("Link preview session changed.");
      const result = await fetchCanonicalLinkPreview(url);
      if (result.availability !== "pending" || attempt === 3) return result;
      await new Promise(resolve => setTimeout(resolve, 4000));
    }
  })();
  // Keep terminal errors cached too: 429 must not trigger a request per bubble.
  requests.set(url, promise);
  return promise;
}
